// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1Kz6w","header":"MessagesList_header__1D9IF","chat":"MessagesList_chat__2C_wy"};